import introspection from "@/graphql"
import { InMemoryCache, TypePolicies } from "@apollo/client"

// Strapi returns each content type `X` as `XEntity { id, attributes }`, and `attributes` has no id: without a merge
// each write replaces it whole, dropping fields another query reads, which then refetches with loading=true (e.g.
// saving an approval remounted the open approval form). GenericMorph lists every content type; components have no
// `…Entity` type, so their keys are unused. `?? []` keeps the app loading if a schema change ever drops the union.
const contentTypes: readonly string[] = introspection.possibleTypes?.GenericMorph ?? []

export const entityTypePolicies: TypePolicies = Object.fromEntries(
  contentTypes.map(type => [`${type}Entity`, { fields: { attributes: { merge: true } } }])
)

/** The one Apollo cache setup, shared by the app, the build-time prerender and tests. */
export const createApolloCache = (): InMemoryCache =>
  new InMemoryCache({
    // Enable result caching only in production for better performance
    resultCaching: import.meta.env.PROD,
    // Required for union types and interfaces in GraphQL schema
    possibleTypes: introspection.possibleTypes,
    // Always add __typename to queries for proper cache normalization
    addTypename: true,
    typePolicies: entityTypePolicies,
  })
